<!-- 敏感词拦截 -->
<template>
  <div>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="24">
        <el-card class="box-card" style="height: 700px">
          <div style="padding: 0px 20px 20px 10px">{{  title  }}</div>
          <div class="text item">
            <el-form :model="ruleForm" ref="registerRef" :rules="rules">
              <div style="padding: 0px 20px 20px 10px">
                <el-form-item label="问题" prop="problem1">
                  <el-input type="textarea" :rows="5" placeholder="请输入您的问题" suffix-icon="none"
                    v-model="ruleForm.problem1" :disabled="xiugai">
                  </el-input>
                </el-form-item>
              </div>

              <div style="padding: 0px 20px 20px 10px">
                <el-form-item label="答案" prop="answer">
                  <el-input type="textarea" :rows="5" placeholder="请输入问题答案" suffix-icon="none" v-model="ruleForm.answer"
                    :disabled="xiugai">
                  </el-input>
                </el-form-item>
              </div>
              <div class="dbButton" v-if="butnbn">
                <el-button type="primary" @click="postClick('registerRef')">确认</el-button>
              </div>

              <div class="dbButton" v-if="butnbnxg">
                <el-button type="primary" @click="postClickxiygau('registerRef')">确认</el-button>
              </div>
            </el-form>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';
import login from "@/views/login/login";

export default {
  name: "company",
  props: {
    valid: {
      type: Number,
    },
    title: {
      type: String
    }
  },
  components: {
    Head,
  },
  data() {
    return {
      butnbnxg: false,
      butnbn: false,
      xiugai: false,
      page: 1,
      size: 10,
      EnterpriseeData: [],
      currentPage: 1,
      dataNumber: 0,
      serchVal: "", // 搜索内容
      createTime: "",
      ordertimestart: "", // 开始时间
      ordertimeend: "", // 结束时间
      pagination: true,
      problem1: "",
      answer: "",
      ruleForm: {
        problem1: "", // 作者
        answer: "", // 标题
      },
      // 校验
      rules: {
        problem1: [{ required: true, message: "请输入问题", trigger: "blur" }],
        answer: [{ required: true, message: "请输入答案", trigger: "blur" }],
        // type:[
        //     { required: true, message: '请选择发布类型', trigger: 'blur' },
        // ],
      },
    }
  },
  watch: {
    title: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal == '修改问题') {
          this.butnbn = false
          this.butnbnxg = true
        } else if (newVal == '查看问题') {
          this.xiugai = true
          this.butnbn = false
        } else if (newVal == '新增问题') {
          this.butnbn = true
        }
      },
    }
  },
  created() {
  },
  mounted() {
    this.getIDquery()
  },
  methods: {
    // 修改
    postClickxiygau(formName) {
      this.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.axiosPost(`/questionsAnswers/update`, {
              questions: this.ruleForm.problem1,
              answers: this.ruleForm.answer,
              id: this.valid,
              type: 1,
            }).then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message)
                // this.$router.go(-1)
                this.$router.push({
                  name: "answers",
                  params: {
                    isActive: 0
                  },
                })
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消编辑'
        });
      });


    },
    // 新增
    postClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axiosPost(`/questionsAnswers/add`, {
            questions: this.ruleForm.problem1,
            answers: this.ruleForm.answer,
            type: 1,
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message)
              this.ruleForm.problem1 = ""
              this.ruleForm.answer = ""
              // this.$router.go(-1)
              this.$router.push({
                  name: "answers",
                  params: {
                    isActive: 0
                  },
                })
            }
          })
        }
      })
    },
    // 编辑问题
    getIDquery() {
      this.axiosGet(`/questionsAnswers/findById/${this.valid}`, {
        params: {
          type: 1
        }
      }).then((res) => {
        if (res.code == 200) {
          this.ruleForm.answer = res.data.answers
          this.ruleForm.problem1 = res.data.questions
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

  .dbButton {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
}
</style>
